import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Api from "../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const validationSchema = yup.object().shape({
  nome_pt: yup.string().required("Nome em PT obrigatório"),
  url: yup
    .string()
    .required("Slug obrigatório")
    .matches(/^[a-z0-9-]+$/, "Use apenas letras minúsculas, números e hífens"),
});

export default function NewCategoria({ loadCategorias, setOpenModalNew }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  const onSubmit = (data) => {
    setLoading(true);
    data.ativado = data.ativado ? 1 : 0;
    Api.post("/guias/categorias/new", data)
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadCategorias();
          setOpenModalNew(false);
        } else {
          swal("Erro!", response.data.message, "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Nova Categoria</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container className="form">
          <Grid item lg={8} className="field">
            <label>Slug (URL)</label>
            <input type="text" {...register("url")} />
            <span className="error">{errors.url?.message}</span>
          </Grid>
          <Grid item lg={4} className="field">
            <label>
              <input type="checkbox" defaultChecked {...register("ativado")} /> Ativada
            </label>
          </Grid>
          <Grid item lg={12} className="field">
            <Tabs>
              <TabList>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} alt="" />
                </Tab>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} alt="" />
                </Tab>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} alt="" />
                </Tab>
              </TabList>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Nome (PT)</label>
                  <input type="text" {...register("nome_pt")} />
                  <span className="error">{errors.nome_pt?.message}</span>
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Nome (EN)</label>
                  <input type="text" {...register("nome_en")} />
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Nome (ES)</label>
                  <input type="text" {...register("nome_es")} />
                </Grid>
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a href="#" className="cancel" onClick={() => setOpenModalNew(false)}>
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
